export default "__VITE_PUBLIC_ASSET__2150ae36__"